// extracted by mini-css-extract-plugin
export default {"badge":"Cards_badge__fzbLD","cards":"Cards_cards__qwjTj","logo":"Cards_logo__E3dgp"};